import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 功能点
 * @enum
 * @version 1.0.0
 */
enum FunctionPoint
{
    /**
     * 店铺装修
     * @member
     */
     DIY = 1,

    /**
     * 体检预约
     * @member
     */
     Physical = 2,

    /**
     * 眼科预约
     * @member
     */
    Eye = 3,

    /**
     * 齿科预约
     * @member
     */
    Teeth = 4,

    /**
     * 科室管理
     * @member
     */
     DepartmentManage = 5,

    /**
     * 医生管理
     * @member
     */
     DoctorManage = 6,

     /**
      * 同步市场库存
      * @member
      */
      SyncStock = 7,

      /**
       * 绿通
       * @member
       */
       GreenPath = 8
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(FunctionPoint,
{
    DIY:
    {
        alias: "店铺装修",
        description: ""
    },
    Physical:
    {
        alias: "体检预约",
        description: ""
    },
    Eye:
    {
        alias: "眼科预约",
        description: ""
    },
    Teeth:
    {
        alias: "齿科预约",
        description: ""
    },
    DepartmentManage:
    {
        alias: "科室管理",
        description: ""
    },
    DoctorManage:
    {
        alias: "医生管理",
        description: ""
    },
    SyncStock:
    {
        alias: "同步市场库存",
        description: ""
    },
    GreenPath:
    {
        alias: "绿通",
        description: ""
    }
});

export default FunctionPoint;
